import React from 'react'
import PropTypes from 'prop-types'
import { Switch, Route, BrowserRouter } from 'react-router-dom'

import { ProtectedRoute } from '../ProtectedRoute'
import AboutPage from '../pages/AboutPage'
import FAQPage from '../pages/FAQPage'
import ApplicationPage from '../pages/ApplicationPage'
import LoginPage from '../pages/LoginPage'
import SubmissionPage from '../pages/SubmissionPage'
import ProjectBoardPage from '../pages/ProjectBoardPage'
import ListingPage from '../pages/ListingPage'
import NavBar from '../components/NavBar'
import Footer from '../components/Footer'

export const Routing = ({ isAuthenticated }) => {
  return (
    <BrowserRouter>
      <NavBar />
      <Switch>
        <Route exact path="/login" component={LoginPage} />
        <ProtectedRoute
          isGrantedAccess={isAuthenticated}
          exact
          path="/about"
          component={AboutPage}
        />
        <ProtectedRoute
          isGrantedAccess={isAuthenticated}
          exact
          path="/submission"
          component={SubmissionPage}
        />
        <ProtectedRoute
          isGrantedAccess={isAuthenticated}
          exact
          path="/applications"
          component={ApplicationPage}
        />
        <ProtectedRoute
          isGrantedAccess={isAuthenticated}
          exact
          path="/listing/:id"
          component={ListingPage}
        />
        <ProtectedRoute
          isGrantedAccess={isAuthenticated}
          exact
          path="/"
          component={ProjectBoardPage}
        />
        <ProtectedRoute isGrantedAccess={isAuthenticated} exact path="/faq" component={FAQPage} />
        <Route path="*" component={() => '404 not found'} />
      </Switch>
      {isAuthenticated && <Footer />}
    </BrowserRouter>
  )
}

Routing.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
}
